import { DatePipe } from '@angular/common';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Component, OnInit, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import saveAs from 'file-saver';
import { Table } from 'primeng/table';
import { Milestone2PaymentBatchStatus } from '../../../models/_enum-collections';
import { ApiResponse } from '../../../models/api-response.model';
import { DownloadPaymentScheduleCSV } from '../../../models/download-payment-schedule-csv.model';
import { Milestone2PaymentBatchDetails } from '../../../models/milestone2-payment-batch-details.model';
import { Milestone2PaymentScheduleBatch } from '../../../models/milestone2-payment-schedule-batch.model';
import { PaymentBatchEngagementExport } from '../../../models/payment-batch-engagement.model';
import { PaymentBatchStatusM2 } from '../../../models/payment-batch-status-m2.model';
import { PaymentScheduleActivitiesM2 } from '../../../models/payment-schedule-activities-m2.model';
import { AppConstants } from '../../common/app-constants';
import { CommonService } from '../../common/common.service';
import { SettingsService } from '../../common/settings.service';
import { CommonSharedModule } from '../../common/shared.module';
import { ExportService } from '../../services/export.service';
import { MsaipPaymentScheduleService } from '../../services/msaip-payment-schedule.service';
import { WorkshopCodeService } from '../../services/workshop-code.service';

@Component({
  selector: 'app-edit-msaip-milestone2-payment-batch',
  templateUrl: './edit-msaip-milestone2-payment-batch.component.html',
  styleUrls: ['./edit-msaip-milestone2-payment-batch.component.scss'],
  standalone: true,
  imports: [CommonSharedModule]
})
export class EditMsaipMilestine2PaymentBatchComponent implements OnInit {
  @ViewChild('dt', { static: false }) dt!: Table;
  pbName!: string;
  editPaymentBatchForm!: FormGroup;
  selectedpaymentBatchStatusID: any;

  engcols!: any[];
  apires!: ApiResponse;
  msgs: any[] = [];
  collecteIdArray: any[] = [];
  collecteId!: string;
  paymentBatchEngagement: PaymentScheduleActivitiesM2[] = [];
  engagementList: PaymentScheduleActivitiesM2[] = [];
  paymentBatchEngagementExport: PaymentBatchEngagementExport[] = [];
  paymentBatchStatus: PaymentBatchStatusM2[] = [];
  dataViewRecsPerPage!: number;
  pageLinksPerPage!: number;
  emptyRecordMsg!: string;
  currentPageInfo!: string;
  totalRecords!: number;
  tblPageNumber!: number;
  marked = false;

  updatePaymentBatch!: Milestone2PaymentBatchDetails;
  selectedEngagements!: PaymentScheduleActivitiesM2[];
  clonedEngs: Record<number, PaymentScheduleActivitiesM2> = {};
  editing = false;
  editingHeaderCheck = false;
  editingNav = false;
  check = false;
  showForm = true;
  disableSubmit = false;
  isSpin = false;
  isSpinEx = false;
  downloadCSV: DownloadPaymentScheduleCSV[] = [];
  copyAssociatedEngagements!: PaymentScheduleActivitiesM2[];
  editedRowEngagementIds: number[] = [];
  addedRowEngagementIds: number[] = [];
  deletedRowEngagementIds: number[] = [];
  firstEditInitEng!: PaymentScheduleActivitiesM2;
  editRowsCtr = 0;
  isShowOnlyAssoctd = true;
  isDataLoading = false;
  loading = false;
  loadingIcon = 'fa-circle-o-notch';

  constructor(
    private msaipPmService: MsaipPaymentScheduleService,
    private formBuilder: FormBuilder,
    private router: Router,
    private route: ActivatedRoute,
    private commonService: CommonService,
    public settings: SettingsService,
    private exportService: ExportService,
    public http: HttpClient,
    public workshopcodeService: WorkshopCodeService
  ) {}

  ngOnInit() {
    this.loading = true;
    this.pbName = this.route.snapshot.paramMap.get('pbName') || '';
    this.editing = false;
    this.editingHeaderCheck = false;
    this.dataViewRecsPerPage = 15;
    this.pageLinksPerPage = AppConstants.dataListPagerLinks;

    this.engcols = [
      { field: 'engagementId', header: 'Activity ID' },
      { field: 'engagementName', header: 'Activity Name' },
      { field: 'engagementSubType', header: 'Sub Type' },
      { field: 'partnerName', header: 'Partner Name' },
      { field: 'tier', header: 'Tier' },
      { field: 'fundingAmount', header: 'Funding Amount' },
      { field: 'paymentProfileStatus', header: 'Profile Status' },
      { field: 'partnerPriority', header: 'Partner Priority' },
      { field: 'blockedStatus', header: 'Blocked Status' },
      { field: 'sspaStatus', header: 'SSPA Status' },
      { field: 'partnerLocation', header: 'Partner Location' },
      { field: 'fiscalYear', header: 'Fiscal Year' },
      { field: 'partnerId', header: 'Partner ID' },
      { field: 'payeeName', header: 'Payee Name' },
      { field: 'amount', header: 'Amount' },
      { field: 'msInvoiceNumber', header: 'MS Invoice Number' },
      { field: 'msInvoicePaidDate', header: 'MS Invoice Paid Date' },
      {
        field: 'paymentCentralTransactionID',
        header: 'Payment Central Transaction ID'
      }
    ];

    this.getPaymentBatchStatus();

    this.editPaymentBatchForm = this.formBuilder.group({
      paymentBatchName: [''],
      paymentBatchScheduleDate: ['', [Validators.required]],
      anticipatedPaymentDate: ['', [Validators.required]],
      actualPaymentCentralDate: [''],
      paymentBatchStatus: ['', [Validators.required]],
      selectedEngs: [''],
      tier: [''],
      fundingAmount: [''],
      amount: [''],
      partnerId: [''],
      payeeName: [''],
      contactName: [''],
      contactEmail: [''],
      emailLanguage: [''],
      accountCode: [''],
      internalOrderOrCostCenter: [''],
      currency: [''],
      netAmount: [''],
      taxAmount: [''],
      msInvoiceNumber: [''],
      msInvoicePaidDate: [''],
      paymentCentralTransactionID: [''],
      paymentCentralRequestID: ['']
    });

    this.getPaymentBatchActivity(this.pbName);
    this.getDownloadCSVFile(this.pbName);
  }

  getDownloadCSVFile(bname) {
    this.msaipPmService
      .getDownloadCSVFileEdit(bname)
      .subscribe(downloadReport => {
        this.downloadCSV = downloadReport;
      });
  }

  downloadExportCSV() {
    this.isSpinEx = true;
    const headers = new HttpHeaders();
    const downloadUrl =
      this.settings.baseUrl + 'api/PoeInformation/DownloadPOEDocs';
    const selectedID = this.selectedEngagements;
    this.http
      .post(downloadUrl, selectedID, {
        headers,
        responseType: 'blob'
      })
      .subscribe(downloadFile => {
        this.isSpinEx = false;
        const file = new Blob([downloadFile], {
          type: 'application/octet-stream'
        });
        saveAs(
          file,
          this.editPaymentBatchForm.controls['paymentBatchName'].value + '.zip'
        );
      });
  }

  downloadExportPoeCSV() {
    this.isSpinEx = true;
    const selectedID = this.selectedEngagements;
    this.msaipPmService
      .downloadExportPoeCSV(selectedID)
      .subscribe(downloadFile => {
        this.isSpinEx = false;
        const file = new Blob([downloadFile], {
          type: 'application/octet-stream'
        });
        saveAs(
          file,
          this.editPaymentBatchForm.controls['paymentBatchName'].value +
            '-Survey' +
            '.zip'
        );
      });
  }

  exportCSV() {
    this.paymentBatchEngagementExport = [];
    this.engagementList.forEach(data => {
      this.paymentBatchEngagementExport.push({
        TransactionId:
          data.engagementId +
          '_' +
          this.workshopcodeService.getWorshopCode(data.engagementSubType || ''),
        PayeeName: data.payeeName,
        ContactName: data.contactName,
        ContactEmail: data.contactEmail,
        EmailLanguage: data.emailLanguage,
        AccountCode: data.accountCode,
        InternalOrderOrCostCenter: data.internalOrderOrCostCenter,
        Currency: data.currency,
        ActualizedAmount: data.actualizedAmount,
        TaxAmount: data.taxAmount,
        PayoutMetric: data.payoutMetric
      });
    });

    this.exportService.exportToCsv(
      this.paymentBatchEngagementExport,
      this.pbName + '.csv'
    );
  }

  setMessage(msg: any, severity: string, noReset?: boolean) {
    if (!noReset) {
      this.msgs = [];
    }
    this.msgs.push({ severity: severity || 'error', detail: msg });
  }

  isEngagementInAssociated(engagementId: number) {
    return this.copyAssociatedEngagements.some(
      e => Number(e.engagementId) === engagementId
    );
  }

  getPaymentBatchActivity(pbName: string): void {
    this.msaipPmService
      .getMsaipMilestone2PaymentBatchActivities(pbName)
      .subscribe(paymentBatchDetails => {
        this.pbName = pbName;
        this.editPaymentBatchForm.controls['paymentBatchStatus'].patchValue({
          id: paymentBatchDetails.paymentScheduleBatch?.paymentBatchStatusId,
          status: paymentBatchDetails.paymentScheduleBatch?.paymentBatchStatus
        });

        const datePipe = new DatePipe('en-US');
        const epaymentBatchScheduleDate = datePipe.transform(
          paymentBatchDetails.paymentScheduleBatch?.paymentBatchScheduleDate,
          'MM/dd/yyyy'
        );
        const eanticipatedPaymentDate = datePipe.transform(
          paymentBatchDetails.paymentScheduleBatch?.anticipatedPaymentDate,
          'MM/dd/yyyy'
        );
        const eactualPaymentCentralDate = datePipe.transform(
          paymentBatchDetails.paymentScheduleBatch?.actualPaymentCentralDate,
          'MM/dd/yyyy'
        );

        this.editPaymentBatchForm.patchValue({
          paymentBatchName:
            paymentBatchDetails.paymentScheduleBatch?.paymentBatchName,
          paymentBatchScheduleDate: epaymentBatchScheduleDate,
          anticipatedPaymentDate: eanticipatedPaymentDate,
          actualPaymentCentralDate: eactualPaymentCentralDate,
          paymentCentralRequestID:
            paymentBatchDetails.paymentScheduleBatch?.paymentCentralRequestID
        });

        this.paymentBatchEngagement = paymentBatchDetails.activities || [];

        this.onAddNewActivity(true);
        this.selectedEngagements = this.paymentBatchEngagement.filter(
          e => e.associated === 1
        );
        this.copyAssociatedEngagements = this.paymentBatchEngagement.filter(
          e => e.associated === 1
        );
        this.engagementList = this.paymentBatchEngagement.filter(
          e => e.associated === 1
        );
        this.paymentBatchEngagement = this.paymentBatchEngagement
          .map(e => {
            return { ...e, editCheckBox: false };
          })
          .filter(e => e.associated === 1);

        this.loading = false;
      });
  }

  pageChange(e) {
    this.tblPageNumber = e.first;
    if (e.first + this.dataViewRecsPerPage > this.totalRecords) {
      this.currentPageInfo =
        'Showing ' +
        (this.tblPageNumber + 1) +
        ' - ' +
        this.totalRecords +
        ' of ' +
        this.totalRecords +
        ' Records';
    } else {
      this.currentPageInfo =
        'Showing ' +
        (this.tblPageNumber + 1) +
        ' - ' +
        (this.tblPageNumber + this.dataViewRecsPerPage) +
        ' of ' +
        this.totalRecords +
        ' Records';
    }
  }

  applyFilter(event) {
    this.totalRecords = event.filteredValue.length;
    if (this.totalRecords === 0) {
      this.currentPageInfo = 'No Record Found';
    }
    if (this.totalRecords > 0 && this.totalRecords > this.dataViewRecsPerPage) {
      this.currentPageInfo =
        'Showing 1 - ' +
        1 * this.dataViewRecsPerPage +
        ' of ' +
        this.totalRecords +
        ' Records';
    }
    if (
      this.totalRecords > 0 &&
      this.totalRecords <= this.dataViewRecsPerPage
    ) {
      this.currentPageInfo =
        'Showing 1 - ' +
        this.totalRecords +
        ' of ' +
        this.totalRecords +
        ' Records';
    }
  }

  reset() {
    if (this.isShowOnlyAssoctd) {
      if (
        this.paymentBatchEngagement === null ||
        this.paymentBatchEngagement.length === 0
      ) {
        this.totalRecords = 0;
        this.currentPageInfo = 'No Records Found';
      } else {
        if (this.dt) {
          this.dt.sortField = 'engagementId';
          this.dt.sortOrder = -1;
          this.dt.reset();
        }

        this.totalRecords = this.paymentBatchEngagement.length;

        if (this.totalRecords === 0) {
          this.currentPageInfo = 'No Record Found';
        }
        if (
          this.totalRecords > 0 &&
          this.totalRecords > this.dataViewRecsPerPage
        ) {
          this.currentPageInfo =
            'Showing 1 - ' +
            1 * this.dataViewRecsPerPage +
            ' of ' +
            this.totalRecords +
            ' Records';
        }
        if (
          this.totalRecords > 0 &&
          this.totalRecords <= this.dataViewRecsPerPage
        ) {
          this.currentPageInfo =
            'Showing 1 - ' +
            this.totalRecords +
            ' of ' +
            this.totalRecords +
            ' Records';
        }
      }
    } else {
      if (this.dt) {
        this.dt.sortField = 'engagementId';
        this.dt.sortOrder = -1;
        this.dt.reset();
      }

      if (
        this.paymentBatchEngagement === null ||
        this.paymentBatchEngagement.length === 0
      ) {
        this.totalRecords = 0;
        this.currentPageInfo = 'No Records Found';
      } else {
        this.totalRecords = this.paymentBatchEngagement.length;
        if (this.totalRecords > 0 && this.totalRecords > this.totalRecords) {
          this.currentPageInfo =
            'Showing 1 - ' +
            1 * this.dataViewRecsPerPage +
            ' of ' +
            this.totalRecords +
            ' Records';
        }
        if (this.totalRecords > 0 && this.totalRecords <= this.totalRecords) {
          this.currentPageInfo =
            'Showing 1 - ' +
            this.dataViewRecsPerPage +
            ' of ' +
            this.totalRecords +
            ' Records';
        }
      }
    }
  }

  selectRow(e, l) {
    const paymentBatchEngagement = this.paymentBatchEngagement.find(
      item => item.engagementId === l.engagementId && item.tier == l.tier
    );

    if (paymentBatchEngagement) {
      if (e === true) {
        paymentBatchEngagement.editCheckBox = true;
      } else {
        paymentBatchEngagement.editCheckBox = false;
      }
    }
  }

  getPaymentBatchStatus() {
    this.msaipPmService.getMilestone2PaymentBatchStatus().subscribe(engList => {
      this.paymentBatchStatus = engList;
    });
  }

  onSubmit() {
    this.loading = true;
    const batchDetails: Milestone2PaymentScheduleBatch = {
      paymentBatchId: this.pbName,
      paymentBatchName:
        this.editPaymentBatchForm.controls['paymentBatchName'].value,
      paymentBatchScheduleDate:
        this.editPaymentBatchForm.controls['paymentBatchScheduleDate'].value,
      anticipatedPaymentDate:
        this.editPaymentBatchForm.controls['anticipatedPaymentDate'].value,
      actualPaymentCentralDate:
        this.editPaymentBatchForm.controls['actualPaymentCentralDate'].value,
      paymentBatchStatusId:
        this.editPaymentBatchForm.controls['paymentBatchStatus'].value.id,
      paymentCentralRequestID:
        this.editPaymentBatchForm.controls['paymentCentralRequestID'].value,
      userId: this.settings.AliasName
    } as any;

    this.updatePaymentBatch = {};

    if (
      batchDetails.paymentBatchStatusId ===
      Milestone2PaymentBatchStatus.Cancelled
    ) {
      this.selectedEngagements = [];
    }
    this.updatePaymentBatch.activities = [];
    if (
      this.selectedEngagements.length !== 0 ||
      this.selectedEngagements.length !== undefined ||
      batchDetails.paymentBatchStatusId ===
        Milestone2PaymentBatchStatus.Cancelled
    ) {
      for (const item of this.selectedEngagements) {
        this.updatePaymentBatch.activities.push({
          engagementId: item.engagementId,
          engagementName: item.engagementName,
          engagementSubType: item.engagementSubType,
          tier: item.tier,
          fundingAmount: item.fundingAmount,
          partnerId: item.partnerId,
          payeeName: item.payeeName,
          contactName: item.contactName,
          contactEmail: item.contactEmail,
          emailLanguage: item.emailLanguage,
          accountCode: item.accountCode,
          internalOrderOrCostCenter: item.internalOrderOrCostCenter,
          currency: item.currency,
          netAmount: item.netAmount,
          taxAmount: item.taxAmount,
          msInvoiceNumber: item.msInvoiceNumber,
          msInvoicePaidDate: item.msInvoicePaidDate,
          paymentCentralTransactionID: item.paymentCentralTransactionID,
          engagementSubID: item.engagementSubID
        });
        const mn = this.paymentBatchEngagement.find(
          it => it.engagementId === item.engagementId
        );
        const msin = mn?.msInvoiceNumber;
        if (msin !== item.msInvoiceNumber) {
          this.collecteIdArray.push(mn?.engagementId);
        }
      }
    }

    if (
      this.selectedEngagements.length === 0 &&
      batchDetails.paymentBatchStatusId !==
        Milestone2PaymentBatchStatus.Cancelled
    ) {
      this.loading = false;
      this.msgs = [];
      this.msgs.push({
        severity: 'error',
        detail: 'Please select any one Activity from the list'
      });
      setTimeout(() => {
        this.msgs = [];
      }, 5000);
      return;
    }
    batchDetails.addids = this.selectedEngagements
      .filter(e => !this.isEngagementInAssociated(Number(e.engagementId)))
      .map(e => e.engagementId)
      .toString();
    batchDetails.editids = this.selectedEngagements
      .filter(e => e.edited)
      .map(e => e.engagementId)
      .toString();
    batchDetails.deleteids = this.copyAssociatedEngagements
      .filter(
        e =>
          !this.selectedEngagements.some(
            e2 => e2.engagementId === e.engagementId
          )
      )
      .map(e => e.engagementId)
      .toString();
    this.updatePaymentBatch.paymentScheduleBatch = batchDetails;
    this.msaipPmService
      .updateMSAIPMilestone2PaymentBatch(this.updatePaymentBatch)
      .subscribe(
        messageResponse => {
          this.loading = false;
          this.apires = messageResponse;
          this.setMessage('Payment Batch Updated Successfully', 'success');
          this.editPaymentBatchForm.reset();
          this.showForm = false;
          this.selectedEngagements = [];
          setTimeout(() => {
            this.router.navigate(['msaip-milestone2-payment-schedule']);
          }, 2000);
        },
        error => {
          this.loading = false;
          let errors: string[] = [];
          const paymentRequestIDWarningMessage =
            'Payment Central RequestID is already exists.';
          if (error.status === 400) {
            errors = this.commonService.getBadRequestErrors(error);
            for (const msg of errors) {
              this.setMessage(msg, 'warn', true);
            }
          } else if (error.error === paymentRequestIDWarningMessage) {
            this.setMessage(paymentRequestIDWarningMessage, 'warn');
          } else {
            this.setMessage(
              'Sorry an Error Occurred while Creating Payment Batch',
              'warn'
            );
          }
        }
      );
  }

  onRowEditInit(eng: PaymentScheduleActivitiesM2) {
    const engagementId = eng.engagementId;
    eng.editCheckBox = true;
    this.clonedEngs[parseInt(engagementId as string)] = { ...eng };

    if (this.editRowsCtr === 0) {
      this.editingHeaderCheck = true;
      this.firstEditInitEng = Object.create(eng);
    }
    this.editRowsCtr++;
    this.disableSubmit = true;
  }

  onRowEditSave(eng: PaymentScheduleActivitiesM2) {
    if (eng.amount !== null) {
      const engagementId = eng.engagementId;
      delete this.clonedEngs[parseInt(engagementId as string)];
      eng.partnerId = this.firstEditInitEng.partnerId;
      eng.payeeName = this.firstEditInitEng.payeeName;
      eng.contactName = this.firstEditInitEng.contactName;
      eng.contactEmail = this.firstEditInitEng.contactEmail;
      eng.emailLanguage = this.firstEditInitEng.emailLanguage;
      eng.accountCode = this.firstEditInitEng.accountCode;
      eng.internalOrderOrCostCenter =
        this.firstEditInitEng.internalOrderOrCostCenter;
      eng.currency = this.firstEditInitEng.currency;
      eng.amount = this.firstEditInitEng.amount;
      eng.netAmount = this.firstEditInitEng.netAmount;
      eng.taxAmount = this.firstEditInitEng.taxAmount;
      eng.msInvoiceNumber = this.firstEditInitEng.msInvoiceNumber;
      eng.msInvoicePaidDate = this.firstEditInitEng.msInvoicePaidDate;
      eng.paymentCentralTransactionID =
        this.firstEditInitEng.paymentCentralTransactionID;
      eng.edited = true;
      eng.tier = this.firstEditInitEng.tier;
      eng.fundingAmount = this.firstEditInitEng.fundingAmount;
      this.editRowsCtr--;
    }
    if (this.editRowsCtr === 0) {
      this.editingHeaderCheck = false;
    }
    this.disableSubmit = false;
  }

  onRowEditCancel(eng: PaymentScheduleActivitiesM2, index: number) {
    const engagementId = eng.engagementId;
    delete this.clonedEngs[parseInt(engagementId as string)];
    const idx = this.selectedEngagements.findIndex(
      e => e.engagementId === eng.engagementId
    );
    this.selectedEngagements.splice(idx, 1);
    this.onAddNewActivity(this.isShowOnlyAssoctd);
    this.paymentBatchEngagement[index].editCheckBox = false;
    this.editing = false;
    this.editRowsCtr--;
    if (this.editRowsCtr === 0) {
      this.editingHeaderCheck = false;
    }
    this.disableSubmit = false;
  }

  cancelSearchNav() {
    this.router.navigate(['msaip-milestone2-payment-schedule']);
  }

  onAddNewActivity(val) {
    this.isShowOnlyAssoctd = val;
    if (this.isShowOnlyAssoctd) {
      if (this.dt) {
        this.dt.filter(1, 'associated', 'equals');
      }
      this.totalRecords = this.paymentBatchEngagement.length;
      if (this.totalRecords === 0) {
        this.currentPageInfo = 'No Record Found';
      }
      if (
        this.totalRecords > 0 &&
        this.totalRecords > this.dataViewRecsPerPage
      ) {
        this.currentPageInfo =
          'Showing 1 - ' +
          1 * this.dataViewRecsPerPage +
          ' of ' +
          this.totalRecords +
          ' Records';
      }
      if (
        this.totalRecords > 0 &&
        this.totalRecords <= this.dataViewRecsPerPage
      ) {
        this.currentPageInfo =
          'Showing 1 - ' +
          this.totalRecords +
          ' of ' +
          this.totalRecords +
          ' Records';
      }
    } else {
      if (this.dt) {
        this.dt.reset();
      }
      this.totalRecords = this.paymentBatchEngagement.length;
      if (this.totalRecords === 0) {
        this.currentPageInfo = 'No Record Found';
      }
      if (
        this.totalRecords > 0 &&
        this.totalRecords > this.dataViewRecsPerPage
      ) {
        this.currentPageInfo =
          'Showing 1 - ' +
          1 * this.dataViewRecsPerPage +
          ' of ' +
          this.totalRecords +
          ' Records';
      }
      if (
        this.totalRecords > 0 &&
        this.totalRecords <= this.dataViewRecsPerPage
      ) {
        this.currentPageInfo =
          'Showing 1 - ' +
          this.totalRecords +
          ' of ' +
          this.totalRecords +
          ' Records';
      }
    }
  }
}
